<template>
  <div
    class="content"
    :style="{
      transform: `scale(${zoom})`,
      transformOrigin: '0 0',
      width: `${initWidth}px`,
      'min-height': `${initHeight}px`,
      'max-height': `${initHeight}px`,
    }"
  >
    <div class="appTitle">
      {{
        cityDetail.cityName +
        (cityDetail.homeTitle
          ? cityDetail.homeTitle
          : "农村集体财产监督管理平台")
      }}
    </div>
    <div class="back" @click="backHome">
      <img src="@/assets/bigData/home.png" alt="" />
      <span>返回首页</span>
    </div>
    <Map
      class="map"
      :formDetail="form"
      :level="level"
      @mapClickMethod="mapClickMethod"
    />
    <transition name="el-zoom-in-center">
      <bigDataHuojia ref="cqjy1" :formDetail="form" class="child1"
    /></transition>
  </div>
</template>

<script>
import bigDataHuojia from "../components/Home/bigData/交易数据_获嘉.vue"
import Map from "../components/Home/bigData/map.vue"
import { cityDetail } from "../util/mainOption"
export default {
  components: {
    bigDataHuojia,
    Map,
  },
  data () {
    return {
      zoom: 1,
      initWidth: 1920,
      initHeight: 1080,
      level: 2,
      form: {
        deptName: "",
        deptId: "",
        deptCode: "",
        level: 3,
      }
    }
  },
  created () {
    const deptName = this.$route.query.deptName || cityDetail.cityName
    const deptId = this.$route.query.deptId || cityDetail.deptId
    const deptCode = this.$route.query.deptCode || cityDetail.deptCode
    const level = this.$route.query.level
    if (deptName) {
      this.form.deptName = deptName
      this.cityName = deptName
    }
    if (deptId) {
      this.form.deptId = deptId
    }
    if (deptCode) {
      this.form.deptCode = deptCode
    }
    if (level) {
      this.form.level = level
      this.level = level
    }
  },
  mounted () {
    window.addEventListener("resize", this.listSize)
    this.listSize()
  },
  methods: {
    backHome () {
      this.$router.push({
        path: "/",
      })
    },
    listSize () {
      let width = window.innerWidth
      let height = window.innerHeight
      this.initHeight = "1080"
      this.initWidth = "1920"
      this.zoom = width / this.initWidth
    },      // 更新数据
    updateData () {
      this.$nextTick(() => {
        this.$refs.cqjy1.getNums()
      })
    },
    // 地图点击
    mapClickMethod (cData) {
      console.log("地图点击事件", cData)
      if (cData == {}) return
      this.cityData = cData

      if (cData.level == 2) {
        this.form.deptId = cData.shiDeptId
        this.form.deptName = cData.shiName
        this.form.deptCode = cData.shiValue
        this.form.level = cData.level

      } else if (cData.level == 3) {
        this.form.deptId = cData.xianDeptId
        this.form.deptName = cData.xianName
        this.form.deptCode = cData.xianValue
        this.form.level = cData.level

      } else if (cData.level == 4) {
        this.form.deptId = cData.xiangDeptId
        this.form.deptName = cData.xiangName
        this.form.deptCode = cData.xiangValue
        this.form.level = cData.level

      } else if (cData.level == 5) {
        this.form.deptId = cData.cunDeptId
        this.form.deptName = cData.cunName
        this.form.deptCode = cData.cunValue
        this.form.level = cData.level

      }

      this.updateData()
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  background: url("../assets/img/backImg.png") no-repeat;
  background-size: 100% 100%;
  width: 100vw;
  height: 100vh;
  position: relative;
  padding: 110px 46px 26px;
  box-sizing: border-box;
  .back {
    display: flex;
    align-items: center;
    border: 3px solid #2187ff;
    border-radius: 12px;
    padding: 7px 10px;
    width: 110px !important;
    height: 20px;
    z-index: 99;
    cursor: pointer;
    background-color: #fff;
    position: absolute;
    top: 8%;
    left: 4%;
    user-select: none;
    img {
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }
    span {
      font-family: MicrosoftYaHei;
      color: #2187ff;
      font-weight: 400;
      font-size: 18px;
      font-weight: 600;
    }
  }
  .appTitle {
    text-shadow: 1px 1px 1px #919191, 1px 2px 1px #919191, 1px 3px 1px #919191,
      1px 4px 1px #919191, 1px 5px 1px #919191,
      1px 18px 6px rgba(10, 10, 10, 0.4), 1px 22px 10px rgba(10, 10, 10, 0.2),
      1px 25px 35px rgba(10, 10, 10, 0.2), 1px 30px 60px rgba(10, 10, 10, 0.4);

    position: absolute;
    top: 4%;
    left: 50%;
    transform: translateX(-51%);
    font-family: FZZYJW;
    font-weight: bold;
    font-size: 36px;
    letter-spacing: 4px;
    color: #fff;
  }
  .map {
    position: absolute;
    top: 150px;
    right: 50%;
    transform: translateX(50%);
    z-index: 99;
  }
  .child1 {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    padding: 150px 46px 26px;
  }
}
</style>